import MainDiv from './MainDiv';
import Card from './Card';
import IMAGE_1 from './images/imgi_29_author-6.png';
import IMAGE_2 from './images/imgi_32_author-1.png';
const ReviewsSection = () => {
  const img ={
    IMAGE_1,
    IMAGE_2,
  }
  const reviews = [
    {
      id: 1,
      name: 'Tafseer Student ',
      role: 'Student',
      rating: 5,
      content: 'This platform transformed my career. The hands-on projects and expert guidance helped me land my dream job in just 6 months!',
      avatar: img.IMAGE_1,
       },
    {
      id: 2,
      name: 'Tajweed Studen',
      role: ' Student',
      rating: 5,
      content: 'The quality of instruction is outstanding. The courses are well-structured and the community support is incredibly helpful.',
      avatar: img.IMAGE_2,
       },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <MainDiv>
        <div className="text-center mb-12">
          <h4> Testimonials </h4>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
           Trusted by Thousands of Students & Tutors
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Join thousands of satisfied learners who have transformed their careers
          </p>
        </div>

        <div className="flex flex-col lg:flex-row justify-center items-stretch gap-8">
          {reviews.map((review) => (
            <Card 
              key={review.id} 
              className="p-8 hover:shadow-xl transition-shadow duration-300 flex flex-col min-h-[400px] w-full lg:w-1/2 max-w-[500px]"
            >
              {/* Stars Rating */}
              <div className="mb-6 text-yellow-500 text-2xl">
                {'★'.repeat(review.rating)}
              </div>
              
              {/* Customer Review Heading */}
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Student Review
              </h3>
              
              {/* Review Content */}
              <div className="mb-8 flex-grow">
                <p className="text-gray-700 text-lg italic leading-relaxed">
                  "{review.content}"
                </p>
              </div>
              
              {/* User Info with Round Image */}
              <div className="flex items-center mt-auto pt-6 border-t border-gray-100">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-white shadow-md"
                />
                <div>
                  <h4 className="text-xl font-semibold text-gray-900">{review.name}</h4>
                  <p className="text-gray-600">{review.role}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </MainDiv>
    </section>
  );
};

export default ReviewsSection;